(ns frontend.ui.component.lp-portal.page.pdf.view
  (:require
   [clojure.string :as s]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]
   [reagent.dom.server :as rs]
   [common.util :as cu]))

;; https://www.papersizes.org/a-sizes-in-pixels.htm
;; https://a-size.com/a4-paper-size/
(def page-width
  "A4 landscape page width (72 PPI)"
  842)

(def page-height
  "A4 landscape page height (72 PPI)"
  595)

(def page-width-portrait
  "A4 portrait page width (72 PPI)"
  595)

(def page-height-portrait
  "A4 portrait page height (72 PPI)"
  842)

(def page-width-one-third
  (/ page-width 3))

(def page-width-half
  (/ page-width 2))

#_(def page-width-third
  (/ page-width 3))

(def page-width-two-third
  (* 2 (/ page-width 3)))

(def default-margin-x 16)
(def default-margin-y 40)

(def page-width-without-margins
  (- page-width (* 2 default-margin-x)))

(def half-page-without-margins
  (- (/ page-width-without-margins 2) (* 2 default-margin-x)))

#_(def one-third-page-without-margins
  (- (/ page-width-without-margins 3) (* 2 default-margin-x)))

(defn rounded-column
  [{:keys [width margin-x margin-y]}]
  (let [column-height (- page-height (* 2 margin-y))
        border-radius margin-x
        svg-string (rs/render-to-static-markup
                    [:svg
                     {:width   width
                      :height  column-height
                      :viewBox (str "0 0 " width 200)}
                     [:rect
                      {:width           "100%"
                       :height          "100%"
                       :rx              border-radius
                       :ry              border-radius
                       :fill            (theme/color [:pdf :fill])
                       :stroke          (theme/color [:pdf :border])
                       :stroke-width    1
                       :stroke-linejoin "round"}]])]
    svg-string))

(defn column-rectangle
  [{:keys [width height _margin-x _margin-y fill-color]}]
  (let [column-height (or height (- page-height 70))
        svg-string (rs/render-to-static-markup
                    [:svg
                     {:width   width
                      :height  column-height
                      :viewBox (str "0 0 " width 200)}
                     [:rect
                      {:width           "100%"
                       :height          "100%"
                       :fill            fill-color
                       :stroke          (theme/color [:pdf :border])
                       :stroke-width    0.5
                       :stroke-linejoin "round"}]])]
    svg-string))


(defn chart-background
  [{:keys [width _margin-x _margin-y height]}]
  (let [column-height height
        border-radius 0
        svg-string (rs/render-to-static-markup
                    [:svg
                     {:width   width
                      :height  column-height
                      :viewBox (str "0 0 " width 200)}
                     [:rect
                      {:width           "100%"
                       :height          "100%"
                       :rx              border-radius
                       :ry              border-radius
                       :fill            (theme/color [:pdf :fill])
                       :fillOpacity     0
                       :stroke          (theme/color [:pdf :border])
                       :stroke-width    0.5
                       :stroke-linejoin "round"}]])]
    svg-string))


(defn chart-background-dynamic-position
  [x y height]
  (let [margin-x 0
        margin-y 40]
    {:stack [
             {:absolutePosition {:x x :y y}
              :svg (chart-background {:width    page-width-half
                                      :height   height
                                      :margin-x margin-x
                                      :margin-y margin-y})}]}))

(defn first-column-background-lifeline-holding
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x 20 :y 45}
     :svg (column-rectangle {:width    (- page-width-one-third default-margin-x)
                             :height (- page-height 80)
                             :margin-x margin-x
                             :margin-y margin-y
                             :fill-color    (theme/color [:palette :granite])})}))

(defn first-half-column-background-lifeline-fund
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x 20 :y 45}
     :svg (column-rectangle {:width    (- page-width-half default-margin-x)
                             :height   (- page-height 90)
                             :margin-x margin-x
                             :margin-y margin-y
                             :fill-color    (theme/color [:palette :granite])})}))

(defn third-column-background-full-height-not-rounded
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x (+ page-width-two-third) :y 36}
     :svg (column-rectangle {:width    page-width-one-third
                             :margin-x margin-x
                             :margin-y margin-y
                             :fill-color    (theme/color [:palette :grey-20])})}))

(defn third-column-background-two-thirds-height-not-rounded
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x (+ page-width-two-third) :y 24}
     :svg (column-rectangle {:width    (- page-width-one-third 20)
                             :height   (- page-height (/ page-height 3))
                             :margin-x margin-x
                             :margin-y margin-y
                             :fill-color    (theme/color [:palette :granite])})}))


(defn second-column-background
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x (+ page-width-one-third) :y margin-y}
     :svg (rounded-column {:width    page-width-one-third
                           :margin-x margin-x
                           :margin-y margin-y})}))

(defn second-column-background-half-page
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x (+ page-width-half) :y margin-y}
     :svg (rounded-column {:width    (- page-width-half margin-x)
                           :margin-x margin-x
                           :margin-y margin-y})}))

(defn third-column-background
  []
  (let [margin-x 16
        margin-y 40]
    {:absolutePosition {:x (+ page-width-two-third) :y margin-y}
     :svg (rounded-column {:width    (- page-width-one-third margin-x)
                           :margin-x margin-x
                           :margin-y margin-y})}))

(defn page-title
  [{:keys [fund-name page-title toc-item]}]
  {:stack [{:absolutePosition {:x 0 :y 0}
            :text             page-title
            :tocItem          toc-item
            :fontSize         0
            :color            "#ffffff"}
           ;; TODO: test if we can remove ,MEUR ,E etc from end of the page-tltle and add it as separate text

           {:text     [(str (s/upper-case (or fund-name ""))
                            (when fund-name " - ")
                            (s/upper-case (or page-title "")))]
            :bold     true
            :margin   [16 16 0 0]
            :fontSize 12
            :color    (theme/color [:text :primary :color])}]})


(defn title-band-svg
  [{:keys [width height tip fill stroke stroke-width]
    :or   {height 35
           tip    34
           fill   "#ffffff"
           stroke nil
           stroke-width 0}}]
  (let [w   (double width)
        h   (double height)
        t   (double tip)
        pts (str "0,0 " w ",0 " (- w t) "," h " 0," h)]
    (rs/render-to-static-markup
     [:svg {:width w :height h :viewBox (str "0 0 " w " " h)}
      [:polygon {:points pts
                 :fill fill
                 :stroke (or stroke "none")
                 :stroke-width stroke-width}]])))

(defn page-title-vertical-layout
  [{:keys [_fund-name page-title toc-item toc-title
           page-width left-margin right-margin
           band-height band-tip band-y band-fill]
    :or   {page-width 595
           left-margin 0
           right-margin 40
           band-height 40
           band-tip 34
           band-y 50
           band-fill "#000000"}}]
  (let [inner-w   (- page-width left-margin right-margin)
        band-w    (/ inner-w 1.67)
        svg-band  (title-band-svg {:width band-w
                                   :height band-height
                                   :tip band-tip
                                   :fill band-fill
                                   :stroke (theme/color [:pdf :border])
                                   :stroke-width 0})]
    {:stack
     [{:svg               svg-band
       :absolutePosition  {:x left-margin :y band-y}}
      
      {:absolutePosition {:x left-margin :y 0}
       :text             (or toc-title page-title)
       :tocItem          toc-item
       :fontSize         0
       :color            "#ffffff"}
      
      {:absolutePosition {:x 20 :y 53}
       :font     "MarlideDisplay"
       :text     (str (or page-title ""))
       :margin   [left-margin (+ band-y 32) 0 0]
       :fontSize 26
       :color    "#ffffff"}]}))

(defn page-title-with-line
  [{:keys [fund-name page-title toc-item reporting-period reference-date lower-case-title? holding-logo] :as _data}]
  {:stack [{:absolutePosition {:x 0 :y 0}
            :text             page-title
            :tocItem          toc-item
            :fontSize         0
            :color            (theme/color [:pdf :heading])}

           {:text     [(if lower-case-title?
                         (str (or fund-name "")
                              (when (and fund-name page-title) " - ")
                              (or page-title ""))
                         (str (s/upper-case (or fund-name ""))
                              (when (and fund-name page-title) " - ")
                              (s/upper-case (or page-title ""))))]
            :bold     true
            :margin   [0 8 0 16]
            :fontSize 10
            :color    (theme/color [:text :primary :color])}
           (when reporting-period
             {:text             [(str reporting-period)]
              :absolutePosition {:x 790 :y 10}
              :fontSize         8
              :color            (theme/color [:pdf :footer :text])
              :margin           [0 0 -10 0]})
           (when reference-date
             {:text             [(fu/format-date-ts reference-date "." true)]
              :absolutePosition {:x 780 :y 10}
              :fontSize         8
              :color            (theme/color [:pdf :footer :text])
              :margin           [0 0 -10 0]})
           (when holding-logo
             {:image holding-logo
              :width 80
              :absolutePosition {:x 730 :y 5}})
           {:canvas [{:type      "line"
                      :x1        -20
                      :y1        -16
                      :x2        842
                      :y2        -16
                      :lineWidth 0.5
                      :color     (theme/color [:pdf :border])}]}]})

(defn holding-page-logo
  [{:keys [page-title holding-logo exited? cross-fund-investment?] :as _data}]
  (let [logo-width   85
        logo-height  34
        logo-x       (- page-width 20 logo-width)
        logo-y       12
        tags-x       20
        tags-y       28
        tags-gap     6
        badge-width  28
        badge-height 12
        badge-font-size 7
        cross-fund-width 92
        exited-badge-x tags-x
        cross-fund-badge-x (if exited?
                             (+ exited-badge-x badge-width tags-gap)
                             tags-x)
        exited-badge-bg
        (when exited?
          {:absolutePosition {:x exited-badge-x :y tags-y}
           :canvas [{:type      :rect
                     :x         0
                     :y         0
                     :w         badge-width
                     :h         badge-height
                     :r         3
                     :color     "#00BE8D"
                     :lineWidth 0}]})
        exited-badge-text
        (when exited?
          {:absolutePosition {:x exited-badge-x :y (- tags-y 0.5)}
           :table  {:widths [badge-width]
                    :body   [[{:text      "EXITED"
                               :color     "#FFFFFF"
                               :bold      false
                               :fontSize  badge-font-size
                               :alignment "center"}]]}
           :layout {:hLineWidth    (fn [_ _] 0)
                    :vLineWidth    (fn [_ _] 0)
                    :paddingLeft   (fn [_ _] 0)
                    :paddingRight  (fn [_ _] 0)
                    :paddingTop    (fn [_ _] 2)
                    :paddingBottom (fn [_ _] 2)}
           :heights badge-height})
        cross-fund-badge-bg
        (when cross-fund-investment?
          {:absolutePosition {:x cross-fund-badge-x :y tags-y}
           :canvas [{:type      :rect
                     :x         0
                     :y         0
                     :w         cross-fund-width
                     :h         badge-height
                     :r         3
                     :lineColor "#00BE8D"
                     :lineWidth 1}]})
        cross-fund-text
        (when cross-fund-investment?
          {:absolutePosition {:x cross-fund-badge-x :y (- tags-y 0.5)}
           :table  {:widths [cross-fund-width]
                    :body   [[{:text      "CROSS-FUND INVESTMENT"
                               :color     "#00BE8D"
                               :bold      false
                               :fontSize  badge-font-size
                               :alignment "center"}]]}
           :layout {:hLineWidth    (fn [_ _] 0)
                    :vLineWidth    (fn [_ _] 0)
                    :paddingLeft   (fn [_ _] 0)
                    :paddingRight  (fn [_ _] 0)
                    :paddingTop    (fn [_ _] 2)
                    :paddingBottom (fn [_ _] 2)}
           :heights badge-height})]

    {:stack [(merge {:text             [page-title]
                     :bold             true
                     :margin           [8 8 0 8]
                     :fontSize         10
                     :color            (theme/color [:text :primary :color])
                     :absolutePosition {:x 20 :y 10}}
                    (when (= (theme/get-theme) :theme.lp-portal/lifeline)
                      {:font     "SuperiorTitleBlack"
                       :fontSize 11
                       :bold     false
                       :color    "#000000"}))
             (when-not (cu/blank-value? holding-logo)
               {:image            holding-logo
                :margin           [8 8 0 8]
                :fit              [logo-width logo-height]
                :absolutePosition {:x logo-x :y logo-y}})
             exited-badge-bg
             exited-badge-text 
             cross-fund-badge-bg
             cross-fund-text]}))


(defn page
  ([title content]
   (page nil title content))
  ([background title content]
   (page background title content nil))
  ([background title content options]
   (merge options
          {:title      title
           :background background
           ;TODO: render background in stack with absolute position
           :content    (merge {:stack (->> [background title content]
                                           (remove nil?))}
                              options)})))


(defn toc-page
  [{:keys [cover-image report-data line-height]}]
  (let [toc-text-margin-x 50
        toc-text-margin-y 70
        toc-bg-width page-width-half
        toc-bg-height page-height
        toc-text-width (- page-width-half (* 2 toc-text-margin-x))
        nest-logo? (:nest-logo? report-data)]
    (page
     "TOC"
     {:stack [{:absolutePosition {:x 0 :y 0}
               :image cover-image
               :width page-width}
              {:absolutePosition {:x 50 :y 50}
               :stack [{:svg    (if nest-logo? theme/nest-capital-logo-white (theme/svg-logo-light))
                        :fit    (if nest-logo? [325 100] [260 75])
                        :margin (if nest-logo? [0 35 0 50] [0 0 0 16])}
                       {:text     (s/upper-case (or (:fund-name report-data) ""))
                        :fontSize 14
                        ;:bold     true
                        :color    (theme/color [:pdf :landing-page :text])
                        :margin   [0 0 0 12]}
                       ;; Copy this to web
                       {:text     (-> report-data
                                      :reference-date
                                      (fu/format-date-ts "." true)
                                      (or "")
                                      (s/upper-case))
                        :fontSize 14
                        ;:bold     true
                        :color    (theme/color [:pdf :landing-page :text])}]}
              {:absolutePosition {:x page-width-half :y 0}
               :svg (rs/render-to-static-markup
                     [:svg
                      {:width   toc-bg-width
                       :height  toc-bg-height
                       :viewBox (str "0 0 " toc-bg-width 200)}
                      [:rect
                       {:width  "100%"
                        :height "100%"
                        :fill   (theme/color [:pdf :fill])}]])}
              {:absolutePosition {:x (+ page-width-half toc-text-margin-x)
                                  :y toc-text-margin-y}
               :columns [{:color      (theme/color [:pdf :toc :text])
                          :lineHeight (or line-height 1.55)
                          :toc        {:title {:text     "Table of contents"
                                               :margin   [0 0 0 10]
                                               :fontSize 10
                                               :bold     true}}
                          :width      toc-text-width}]}]})))
